// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__6Hqpc","checkbox":"SuperCheckbox_checkbox__D2FHo","spanClassName":"SuperCheckbox_spanClassName__ty3Cc"};